<template>
  <!-- 完善资料  获取抽奖资格 -->
  <div
    class="puzzle-form register-data text-center"
    :class="formState ? 'bind-data' : ''"
  >
    <div class="content">
      <div class="form-outer">
        <div class="inner">
          <div class="ftop">
            <div class="ft-left">
              <img src="@/assets/img/jiangbei.svg" />
              <template v-if="!relateUrl">
                <div v-if="rankIndex == 1">{{ rankIndex }}st</div>
                <div v-else-if="rankIndex == 2">{{ rankIndex }}nd</div>
                <div v-else-if="rankIndex == 3">{{ rankIndex }}rd</div>
                <div v-else>{{ rankIndex }}th</div>
              </template>
            </div>
            <div class="ft-right" v-if="!relateUrl">
              <div class="title bold">Congratulations!</div>
              <div class="time">
                You finished in {{ time }}<br />
                You currently rank at
                <span v-if="rankIndex == 1">{{ rankIndex }}st</span>
                <span v-else-if="rankIndex == 2">{{ rankIndex }}nd</span>
                <span v-else-if="rankIndex == 3">{{ rankIndex }}rd</span>
                <span v-else>{{ rankIndex }}th</span>
              </div>
            </div>
            <div class="ft-right" style="padding-top: 8px" v-else>
              <div class="title bold" v-if="second <= limit">
                Congratulations!
              </div>
              <div class="title bold" v-else>Success!</div>
            </div>
          </div>
          <div class="text">
            <template v-if="second > limit">
              <p>It took you {{ second }} s finished the puzzle.</p>
              <p>
                You are only one step away from the lucky draw opportunity. Do
                it in {{ limit }} s for getting the draw chance.
              </p>
            </template>
            <template v-else>
              <p>
                WOW! Finished it less than {{ limit }} s, get 1 chance to draw!
              </p>
            </template>
          </div>
          <div class="form text-left">
            <template v-if="!relateUrl || (relateUrl && second <= limit)">
              <div class="form-item">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="formData.nickname"
                />
              </div>
              <div class="form-item">
                <input
                  type="text"
                  class="form-control area-code fl"
                  placeholder="Area Code"
                  v-model="formData.areaCode"
                />
                <input
                  type="text"
                  class="form-control code-body"
                  placeholder="Phone Number"
                  v-model="formData.mobile"
                />
              </div>
              <div class="form-item">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  v-model="formData.email"
                />
              </div>
              <div class="form-item">
                <select
                  class="form-control myselect"
                  v-model="formData.country"
                  :class="formData.country ? 'choosed' : ''"
                >
                  <option value="">Country & Region</option>
                  <option
                    :value="item.id"
                    v-for="(item, index) in regions"
                    :key="index"
                  >
                    {{ item.name_en }}
                  </option>
                </select>
              </div>
            </template>
            <div
              class="submit-btn text-center"
              @click="handleSubmit(0)"
              v-if="!relateUrl"
            >
              Submit
            </div>
            <div
              class="submit-btn text-center"
              @click="handleSubmit(1)"
              v-else-if="second <= limit"
            >
              Lucky Draw
            </div>
            <div class="submit-btn text-center" @click="handleSubmit(2)" v-else>
              Try Again
            </div>
          </div>
          <div class="iconfont close" @click="handleCloseForm">&#xe6e2;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountry, getMyRank, submitAddTime } from "@/util/data.js";
import { showToast } from "@/util/utils.js";
export default {
  props: ["time", "showform", "submitTime", "rankIndex", "hasPrize"],
  data() {
    return {
      limit: 20,
      relateId: 0,
      relateRoute: "",
      relateUrl: "",
      second: 0,
      // formState:3,
      formData: {
        nickname: "",
        areaCode: "",
        mobile: "",
        email: "",
        country: "",
        countryName: "",
      },
      description:
        "Please be sure to fill in valid address and contact information,<br>otherwise it will be regarded as giving up the prize automatically.",
      regions: [],
      rankInfo: {},
    };
  },
  created() {
    this.relateId = this.$route.params.relateId;
    this.relateRoute = this.$route.query.name;
    // this.limit = this.$route.query.gt ? parseFloat(this.$route.query.gt) : 20;
    // if (this.relateId && this.relateRoute)
    //   this.relateUrl = [
    //     window.location.href.replace(this.$route.fullPath, ""),
    //     this.relateRoute,
    //     this.relateId,
    //   ].join("/");
    this.limit = 120;
    if (this.relateId)
      this.relateUrl = [
        window.location.href.replace(this.$route.fullPath, ""),
        "luckyegg",
        this.relateId,
      ].join("/");
    this.getRegions();
    let userDetail = this.$store.state.userDetail;
    if (userDetail) {
      this.initFormData(userDetail);
    }

    let token =
      this.$store.state.token || window.localStorage.getItem("token") || "no";
    if (token) {
      this.getMyrank();
    }
    if (this.time) {
      let t = this.time.split(":");
      this.second = (
        parseInt(t[0]) * 60 +
        parseFloat(t[1]) +
        parseInt(t[1]) / 1000
      ).toFixed(1);
    }
  },
  mounted() {},
  computed: {
    // formState() {
    //   return this.$store.state.showForm;
    // },
    formState: {
      get() {
        return this.$store.state.showForm;
      },
      set(v) {
        this.$store.state.showForm = v;
      },
    },
    token: function () {
      return this.$store.state.token || window.localStorage.getItem("token");
    },
  },
  watch: {
    formState(newVal) {
      if (!newVal && newVal !== 0) return;
      let userDetail = this.$store.state.userDetail;
      if (userDetail && newVal === 0) {
        this.initFormData(userDetail);
      }
    },
    token() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "no";
      if (token) {
        this.getMyrank();
      }
    },
  },
  methods: {
    getRegions() {
      getCountry().then((res) => {
        if (res.code == 200) {
          let formData = this.formData;
          this.regions = res.data;
          if (formData.country) {
            formData.countryName = this.getCountryName(formData.country);
          }
          this.formData = formData;
        }
      });
    },
    initFormData(userDetail) {
      let arr = userDetail.mobile ? userDetail.mobile.split("-") : [];
      let mobile = arr[1] ? arr[1] : arr[0];
      let areaCode = arr[1] ? arr[0] : "";
      let countryName = this.getCountryName(userDetail.country);
      let formData = {
        nickname: userDetail.nickname || "",
        areaCode: areaCode || "",
        mobile: mobile || "",
        email: userDetail.email || "",
        country: userDetail.country || "",
        countryName,
      };
      this.formData = formData;
    },
    getCountryName(id) {
      let len = this.regions.length;
      for (let i = 0; i < len; i++) {
        let item = this.regions[i];
        if (item.id == id) {
          return item.name_en;
          break;
        }
      }
      return "";
    },
    handleSubmit(type = 0) {
      if (type == 2) {
        this.$emit("start");
        this.handleCloseForm();
        return;
      }
      // 验证邮箱的正则表达式
      const regEmail =
        /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/;
      let nickname = this.formData.nickname,
        areaCode = this.formData.areaCode,
        mobile = this.formData.mobile,
        email = this.formData.email,
        country = this.formData.country;
      if (!nickname) {
        showToast(this, "Please fill in name!");
        return;
      }
      if (!areaCode) {
        showToast(this, "Please fill in area code!");
        return;
      }
      if (!mobile) {
        showToast(this, "Please fill in mobile!");
        return;
      }
      if (!email) {
        showToast(this, "Please fill in mail!");
        return;
      }
      if (!regEmail.test(email)) {
        showToast(this, "Please fill a correct email address!");
        return;
      }
      if (!country) {
        showToast(this, "Please fill in country!");
        return;
      }
      let tel = areaCode + "-" + mobile,
        token = this.$store.state.token || window.localStorage.getItem("token");
      let userDetail = this.$store.state.userDetail || {};
      userDetail.nickname = nickname;
      userDetail.mobile = tel;
      userDetail.email = email;
      userDetail.country = country;
      this.$store.commit("updateUserDetail", userDetail);
      this.$store.commit("updateRoleState", false);
      this.updateUserInfo({
        nickname,
        mobile: tel,
        email,
        country,
      });
    },
    handleCloseForm() {
      this.$emit("changeShowForm", false);
      this.formState = -1;
      this.$store.commit("updateRoleState", false);
    },
    updateUserInfo(data) {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "no";
      data.activity_id = this.$route.params.id;
      data.cost_time = this.submitTime;
      submitAddTime(data, token).then((res) => {
        if (res.code == 1) {
          showToast(this, "Success!");
          if (this.relateUrl) window.location.href = this.relateUrl;
        } else {
          showToast(this, res.msg);
        }
        if (!this.relateUrl) this.handleCloseForm();
      });
    },
    getMyrank() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "no";
      getMyRank(
        {
          activity_id: this.$route.params.id,
        },
        token
      )
        .then((res) => {
          if (res.code === 1) {
            this.rankInfo = res.data;
          } else {
            var msg = res.message || res.msg || "Fail!";
            //showToast(this, msg);
          }
        })
        .catch((err) => {
          showToast(this, "Fail!");
        });
    },
  },
};
</script>

<style scoped>
.puzzle-form {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 6;
  background: rgba(0, 0, 0, 0.6);
}
.puzzle-form .content {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  left: 50%;
  top: 50%;
  position: absolute;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 7px;
  box-sizing: content-box;
}
.puzzle-form .content .inner {
  padding: 45px 4.6% 35px 4.6%;
  position: relative;
}

.inner .form {
  margin-top: 20px;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c3c3c3;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c3c3c3;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c3c3c3;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c3c3c3;
}
.inner .form .form-control {
  height: 43px;
  border: 1px solid #939393;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 15px;
  padding-left: 10px;
  color: #1d1d1d;
}
.inner .form .form-control.myselect {
  color: #c3c3c3;
}
.inner .form .form-control.choosed {
  color: #1d1d1d;
}
.inner .form .form-control.area-code {
  width: 32.7%;
  float: left;
}
.inner .form .form-control.code-body {
  width: 62.6%;
  float: right;
}
.content .submit-btn {
  width: 215px;
  height: 45px;
  background: #3e9af9;
  border-radius: 5px;
  text-align: center;
  line-height: 45px;
  color: white;
  font-size: 20px;
  letter-spacing: 1px;
  margin: 22px auto;
  margin-bottom: 0;
  cursor: pointer;
}
.content .close {
  color: #1d1d1d;
  padding: 10px;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .puzzle-form .content {
    width: calc(100% - 30px);
  }
}
.ftop {
  color: rgba(255, 200, 77, 1);
  overflow: hidden;
  width: 280px;
  margin: 0 auto;
}
.ft-left {
  float: left;
  font-weight: 400;
  font-size: 18px;
}
.ft-left img {
  width: 57px;
}
.ft-right {
  float: left;
  text-align: left;
  margin-left: 20px;
}
.ft-right .title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #0f173a;
}
.ft-right .time {
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  line-height: 20px;
  color: #0f173a;
}
.text {
  text-align: center;
  color: #1d1d1d;
  margin-top: 18px;
  font-size: 14px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/form.vue